import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { CompanyDetailQuery } from 'interfaceAdapter/queries/CompanyDetail';
import { ICompany } from 'domain/entities/Company/Company';
import { useParams } from 'react-router-dom';
import { agentUserContext } from 'application/contexts/useAgentUser';
import { useLoading } from 'application/contexts/useLoading';
import { CompanyRegistrationProfileInfoQuery } from 'interfaceAdapter/queries/CompanyRegistrationProfileInfo';
import { IIndustry } from 'domain/entities/Industry/Industry';

export const useCompanyDetailAfterMatch = () => {
    const diContainer = useContext(diContainerContext);
    const companyDetailQuery = diContainer.resolve(CompanyDetailQuery);
    const companyRegistrationProfileInfoQuery = diContainer.resolve(CompanyRegistrationProfileInfoQuery);
    const { loading, setLoading } = useLoading();
    const [company, setCompany] = useState<ICompany>();
    const [areaChoices, setAreaChoices] = useState<string[][]>([]);
    const [prefectureChoices, setPrefectureChoices] = useState<string[][]>([]);
    const [employeeChoices, setEmployeeChoices] = useState<string[][]>([]);
    const [revenueChoices, setRevenueChoices] = useState<string[][]>([]);
    const [industryChoices, setIndustryChoices] = useState<IIndustry[]>([]);
    const [profitLevelChoices, setProfitLevelChoices] = useState<string[][]>([]);
    const [netAssetsLevelChoices, setNetAssetsLevelChoices] = useState<string[][]>([]);
    const { user } = useContext(agentUserContext);
    const params = useParams();

    useEffect(() => {
        if (params.company_id === undefined) {
            return;
        }
        const fetchData = async () => {
            setLoading(true);
            try {
                const resCompanies = await companyDetailQuery.fetchDetail(Number(params.company_id));
                setCompany(resCompanies);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

        const fetchProfileInfoData = async () => {
            const data = await companyRegistrationProfileInfoQuery.fetch();
            setAreaChoices(data.area_choices);
            setPrefectureChoices(data.prefecture_choices);
            setEmployeeChoices(data.employee_choices);
            setRevenueChoices(data.revenue_choices);
            setIndustryChoices(data.industries);
            setProfitLevelChoices(data.profit_level_choices);
            setNetAssetsLevelChoices(data.net_assets_level_choices);
        };
        fetchProfileInfoData();
    }, []);

    return {
        user,
        loading,
        company,
        areaChoices,
        prefectureChoices,
        employeeChoices,
        revenueChoices,
        industryChoices,
        profitLevelChoices,
        netAssetsLevelChoices,
    };
};
